import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import FilterMenuWrapper from './FilterMenuWrapper/FilterMenuWrapper';
import styles from './PageTable.module.scss';

export type FilterItemProps = {
  openStateToggler: (event: React.MouseEvent) => void;
};

type TitleItem =
  | {
      name: string;
      filterItem: React.FC<FilterItemProps>;
    }
  | string;

type Titles = TitleItem[];

export type Rows =
  | {
      id: string | number;
      items: (string | number | JSX.Element)[];
    }[]
  | [];

type PageTableProps = {
  titles: Titles;
  rows: Rows;
  baseComponentURL: string;
  isLoading: boolean;
};

const PageTable: React.FC<PageTableProps> = ({
  titles,
  rows,
  baseComponentURL,
  isLoading,
}) => {
  const navigate = useNavigate();

  const goToDetailPage = (id: string | number) => {
    navigate(`${baseComponentURL}/${id}`);
  };

  return (
    <div className={styles.loadList}>
      <table className={styles.pageTable}>
        <thead className={styles.pageTable__head}>
          <tr>
            {titles.map((elem, index) => {
              if (typeof elem === 'string') {
                return (
                  <th className={styles.pageTable__head__cell} key={index}>
                    {elem}
                  </th>
                );
              }

              return (
                <th className={styles.pageTable__head__cell} key={index}>
                  <FilterMenuWrapper name={elem.name} item={elem.filterItem} />
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody className={styles.pageTable__body}>
          {rows.map(({ items, id }, index) => {
            const rowItems = items.map((item, index) => (
              <td className={styles.pageTable__body__row__cell} key={index}>
                {item}
              </td>
            ));

            return (
              <tr
                className={styles.pageTable__body__row}
                onClick={() => goToDetailPage(id)}
                key={index}
              >
                {rowItems}
              </tr>
            );
          })}
        </tbody>
      </table>
      {isLoading && (
        <Spin className={styles.pageTable__placeholder} size="large" />
      )}
      {!isLoading && !rows.length && (
        <span className={styles.pageTable__placeholder}>No data available</span>
      )}
    </div>
  );
};

export default PageTable;
